import { csv } from "d3-fetch";
import groupBy from "lodash/groupBy";
import JUDGES from "../data/2019__workloads-simple.csv";
import COUNTY_CLASSES from "../data/county_classes.csv";
import { COUNTY_CLASSES_POP } from "./constants";
import { formatK } from "./dataHelpers/formatters";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(JUDGES), csv(COUNTY_CLASSES)]).then(
    ([judgesData, countyClasses]) => {
      // COUNTY DATA
      // Exclude Philadelphia
      const cleanCountyClass = countyClasses
        .filter((datum) => datum.id !== "philadelphia")
        .sort((a, b) => {
          const nameA = a.id;
          const nameB = b.id;
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });

      // GROUP AND PROCESS JUDGE DATA
      // group data by county class
      let groupedClasses = groupBy(judgesData, "county_class");

      // loop over each class
      groupedClasses = Object.keys(groupedClasses).map((classKey) => {
        const groupClass = groupedClasses[classKey];

        // calculate mean for all judges within class
        const meanClassWorkload =
          groupClass.reduce(
            (accum, currentVal) => accum + +currentVal.workload,
            0
          ) / groupClass.length;

        // group class data by county
        let groupedCounties = groupBy(groupClass, "county");
        groupedCounties = Object.keys(groupedCounties).map((countyKey, idx) => {
          // Get mean for all judges in county
          let groupCounty = groupedCounties[countyKey];
          const meanCountyWorkload =
            groupCounty.reduce(
              (accum, currentVal) => accum + +currentVal.workload,
              0
            ) / groupCounty.length;

          // Clean each judge object: ensure continuous vals are numeric and add new props
          groupCounty = groupCounty.map((judge) => ({
            ...judge,
            caseload: +judge.caseload,
            workload: +judge.workload,
            // variance from avg. workload for all judges in county
            workloadVarCounty:
              (judge.workload - meanCountyWorkload) / meanCountyWorkload,
            // variance from avg. workload for all judges in county class
            workloadVarClass:
              (judge.workload - meanClassWorkload) / meanClassWorkload,
          }));

          // return data for each county
          return {
            label: countyKey,
            categoryVal: idx + 1,
            data: groupCounty,
            meanCountyWorkload,
          };
        });

        // return data for each class
        const { popMin, popMax } = COUNTY_CLASSES_POP[classKey];
        const displayLabel = `${formatK(popMin)} to ${formatK(popMax + 1)}`;
        return {
          label: classKey,
          displayLabel,
          multiSeries: groupedCounties,
          meanClassWorkload,
        };
      });
      const class2ACounties = groupedClasses.splice(
        groupedClasses.length - 1,
        1
      )[0];
      groupedClasses.splice(1, 0, class2ACounties);

      const data = {};
      data.multiGroup = groupedClasses;
      data.countyClasses = cleanCountyClass;

      return data;
    }
  );
};

export default loadData;
